import PageTitle from '../components/PageTitle';
import Gallery from '../components/Gallery/Gallery';

// Create a require context for the images
const imageContext = require.context('../assets/images/content', false, /\.(jpg|jpeg|png)$/);
const getImagePath = (filename) => imageContext(`./${filename}`);

const ArtPortfolio = () => {
	return (
		<>
			<PageTitle title="Art Portfolio" />
			<div className="bg-[#F05860] text-white py-12 md:py-24">
				<div className="container max-w-container-lg">
					<div className="md:grid grid-cols-[1fr_1fr] gap-6">
						<div>
							<h2 className="font-trade-compressed uppercase m-0 text-[1.875rem] font-bold tracking-widest mb-6">ABOUT THE ART</h2>
							<p>
								American photographer Kelli Connell’s <em>Double Life</em> series is a complex body of work documenting dual portraits of a single model over twenty-two years. These portraits poetically reveal one’s interior life of contrasting wants, identities, and internal monologues by elevating the mundane or familiar. The “double life” suggested in these photographs is that we can also interpret the figures as two different people in equally complex and emotionally significant moments. Ultimately, these artworks illustrate not only how we show empathy towards those around us, but also how we care for, argue with, forgive, and love who we are individually. A selection of these photographs will join Progressive’s{' '}
								<a href="https://www.progressive.com/about/art/" target="_blank" rel="noreferrer">
									growing collection of contemporary art.
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="container py-12 max-w-container-lg">
				<Gallery
					title="Kelli Connell:<br/> COMMISSIONED WORKS"
					images={[
						{
							src: getImagePath('Sauna_9x12_300.jpg'),
							caption: 'Sauna',
							year: '2025',
						},
						{
							src: getImagePath('White_Corner_9x12_300.jpg'),
							caption: 'Cornered',
							year: '2025',
						},
						{
							src: getImagePath('Green_Office_9x12_300.jpg'),
							caption: 'Corner Office',
							year: '2025',
						},
						{
							src: getImagePath('Lunch_Break_9x12_300.jpg'),
							caption: 'Lunch Break',
							year: '2025',
						},
						{
							src: getImagePath('Parking_Garage_9x12_300.jpg'),
							caption: 'One More Thing',
							year: '2025',
						},
						{
							src: getImagePath('Corridor_Two_9x12_300.jpg'),
							caption: 'Negotiation',
							year: '2025',
						},
						{
							src: getImagePath('Woods_and_Bridge_9x12_300.jpg'),
							caption: 'About Today',
							year: '2025',
						},
						{
							src: getImagePath('Corner_Conference_9x12_300.jpg'),
							caption: 'Conference',
							year: '2025',
						},
					]}
				/>

				<Gallery
					title="ADDITIONAL WORKS"
					images={[
						{
							src: getImagePath('Connell_2002_The_Space_Between.jpg'),
							caption: 'The Space Between',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2008_Reflection.jpg'),
							caption: 'Reflection',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2008_Ponder.jpg'),
							caption: 'Ponder',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2010_Findings.jpg'),
							caption: 'Findings',
							year: '2010',
						},
						{
							src: getImagePath('Connell_2005_4th_of_July.jpg'),
							caption: '4th of July',
							year: '2005',
						},
						{
							src: getImagePath('Connell_2005_Sunset.jpg'),
							caption: 'Sunset',
							year: '2005',
						},
						{
							src: getImagePath('Connell_2002_Giggle.jpg'),
							caption: 'Giggle',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2010_An_Early_Spring.jpg'),
							caption: 'An Early Spring',
							year: '2010',
						},
						{
							src: getImagePath('Connell_2008_And_It_Was.jpg'),
							caption: 'And It Was',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2008_Woods_and_Roses.jpg'),
							caption: 'Woods and Roses',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2015_Undercurrent.jpg'),
							caption: 'Undercurrent',
							year: '2015',
						},
						{
							src: getImagePath('Connell_2002_Clothesline.jpg'),
							caption: 'Clothesline',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2010_Renovate.jpg'),
							caption: 'Renovate',
							year: '2010',
						},
						{
							src: getImagePath('Connell_2006_Reverie.jpg'),
							caption: 'Reverie',
							year: '2006',
						},
						{
							src: getImagePath('Connell_2019_Photographer.jpg'),
							caption: 'Studio View',
							year: '2019',
						},
						{
							src: getImagePath('Connell_2002_The_Conversation.jpg'),
							caption: 'The Conversation',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2022_Morning_Tea_Placeholder.jpg'),
							caption: 'Morning Tea',
							year: '2022',
						},
						{
							src: getImagePath('Connell_2015_Hers_and_Hers.jpg'),
							caption: 'Hers and Hers',
							year: '2015',
						},
						{
							src: getImagePath('Connell_2024_Still_Summer.jpg'),
							caption: 'Still Summer',
							year: '2024',
						},
						{
							src: getImagePath('Connell_2003_Chamomile.jpg'),
							caption: 'Chamomile',
							year: '2003',
						},
						{
							src: getImagePath('Connell_2002_Kitchen_Tension.jpg'),
							caption: 'Kitchen Tension',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2008_Backgammon.jpg'),
							caption: 'Backgammon',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2002_Picnic.jpg'),
							caption: 'Picnic',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2002_Cartalk.jpg'),
							caption: 'Car Talk',
							year: '2002',
						},
						{
							src: getImagePath('Connell_2019_Violet_Hour.jpg'),
							caption: 'Violet Hour',
							year: '2019',
						},
						{
							src: getImagePath('Connell_2006_Around_Here.jpg'),
							caption: 'Around Here',
							year: '2006',
						},
						{
							src: getImagePath('Connell_2008_Fresh_Air.jpg'),
							caption: 'Fresh Air',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2008_Bed_and_Breakfast.jpg'),
							caption: 'Bed and Breakfast',
							year: '2008',
						},
						{
							src: getImagePath('Connell_2017_Melanies_Place_PLACEHOLDER.jpg'),
							caption: 'Melanie&apos;s Place',
							year: '2017',
						},
						{
							src: getImagePath('Connell_2013_Ascend.jpg'),
							caption: 'Ascend',
							year: '2013',
						},
						{
							src: getImagePath('Connell_2006_Windowsill.jpg'),
							caption: 'Windowsill',
							year: '2006',
						},
						{
							src: getImagePath('Connell_2010_Next_Door.jpg'),
							caption: 'Next Door',
							year: '2010',
						},
						{
							src: getImagePath('Connell_2010_Umbrella.jpg'),
							caption: 'Umbrella',
							year: '2010',
						},
						{
							src: getImagePath('Connell_2015_Lakeside.jpg'),
							caption: 'Lakeside',
							year: '2015',
						},
					]}
				/>
			</div>
		</>
	);
};

export default ArtPortfolio;
